<template>
    <li v-if="level < 1" class="c-m-menu-desktop__item" :class="{ 'c-m-menu-desktop__item--active': isActive(item), 'c-m-menu-desktop__item--has-toggle': hasChildren(item) }" @mouseenter="showChildrenFunc" @mouseleave="hideChildrenFunc">
        <a v-if="item.slug && (item.slug.indexOf('http') !== -1)" class="st1 c-m-menu-desktop__link c-m-menu-desktop__link--heavy c-m-menu-desktop__link--no-underline" :href="item.slug">{{item.title}}</a>
        <router-link v-else-if="item.to" class="st2 c-m-menu-desktop__link c-m-menu-desktop__link--heavy c-m-menu-desktop__link--no-underline" :to="item.to">{{item.title}}</router-link>
        <router-link v-else-if="item.url != '#'" class="st3 c-m-menu-desktop__link c-m-menu-desktop__link--heavy c-m-menu-desktop__link--no-underline" :to="`/info/${item.slug}/`">{{item.title}}</router-link>
        <span v-else-if="item.url == '#'" class="st4 c-m-menu-desktop__link c-m-menu-desktop__link--heavy c-m-menu-desktop__link--no-underline">{{item.title}}</span>
        <span
            class="c-m-menu-desktop__toggle"
            :class="{'c-m-menu-desktop__toggle--toggled': showChildren}"
            v-show="hasChildren(item)">
                <icon :icon="'expand_more'"></icon>
        </span>
        <transition name="c-m-menu-desktop__dropdown--animation">
            <ul class="c-m-menu-desktop__list" :class="classLevel" v-if="hasChildren(item)" v-show="showChildren">
                <menu-item-desktop
                    v-for="(value, key) in item.children"
                    :key="key"
                    :item="value"
                    :level="nextLevel"/>
            </ul>
        </transition>
        {{item.id}}
    </li>
    <li v-else class="c-m-menu-desktop__item" :class="{ 'c-m-menu-desktop__item--active': isActive(item), 'c-m-menu-desktop__item--has-toggle': hasChildren(item) }">
        <router-link v-if="item.to" class="c-m-menu-desktop__link c-m-menu-desktop__link--heavy c-m-menu-desktop__link--no-underline" :to="item.to">{{item.title}}</router-link>
        <router-link v-else-if="item.url" class="c-m-menu-desktop__link c-m-menu-desktop__link--no-underline" :to="`/info/${item.slug}/`">{{item.title}}</router-link>
        <span
            class="c-m-menu-desktop__toggle c-m-menu-desktop__toggle--button"
            :class="{'c-m-menu-desktop__toggle--toggled': showChildren}"
            v-show="hasChildren(item)"
            @click="toggleChildren()"
        >
            <icon :icon="'expand_more'"></icon>
        </span>
        <ul class="c-m-menu-desktop__list" :class="classLevel" v-if="hasChildren(item)" v-show="showChildren">
            <menu-item-desktop
                v-for="(value, key) in item.children"
                :key="key"
                :item="value"
                :level="nextLevel"/>
        </ul>
        {{item.id}}
    </li>
</template>

<script>
    import Icon from '../atoms/AtomIcon.vue';

    export default {
        props: [
            'item',
            'level'
        ],
        components: {
            Icon
        },
        data () {
            return {
                nextLevel: (parseInt(this.level) + 1),
                showChildren: false
            }
        },
        name: 'menu-item-desktop',
        computed: {
            classLevel: function() {
                if (this.level === 0) {
                    return `c-m-menu-desktop__list--level-${this.level + 1} c-m-menu-desktop__dropdown`
                } else {
                    return `c-m-menu-desktop__list--level-${this.level + 1}`
                }
            }
        },
        methods: {
            isActive(currentItem) {
                const currentPage = this.$route.path;
                const id = this.$route.params.id ? this.$route.params.id : '';

                if ( currentPage == currentItem.url || currentPage == '/info/' + currentItem.slug || currentPage == currentItem.to + id ) {
                    return true;
                }
            },
            toggleChildren() {
                if (this.showChildren === true) {
                    this.showChildren = false;
                } else {
                    this.showChildren = true;
                }
            },
            hasChildren(item){
                return item.children && item.children.length ? true : false
            },
            showChildrenFunc() {
                this.showChildren = true;
            },
            hideChildrenFunc() {
                this.showChildren = false;
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/components/molecules/MoleculeMenuItemDesktop.vue